__turbopack_context__.v({
  "buttonCta": "Footer-module__OOfQHG__buttonCta",
  "entityContainer": "Footer-module__OOfQHG__entityContainer",
  "timestamp": "Footer-module__OOfQHG__timestamp",
  "timestampContainer": "Footer-module__OOfQHG__timestampContainer",
});
